import { RealEstateFeatures } from '../../../../../@types/types'
import { estateFeatures } from '../../../../../components/pages/insertionPage/screens/otherFacilities/wrapper/otherFacilitiesFieldsWrapper'
import React from 'react'
import { BuildingTypeOption } from '../../../../../@types/dropdown-types'

export const tenantShortTermAccommodationRentEstateFeaturesList = [
  RealEstateFeatures.BALCONY_TERRACE,
  RealEstateFeatures.GUEST_TOILET,
  RealEstateFeatures.ELEVATOR,
  RealEstateFeatures.SHARED_GARDEN,
  RealEstateFeatures.BASEMENT,
  RealEstateFeatures.STEPLESS_ACCESSIBLE,
]

export const createTenantShortTermAccommodationRentEstateFeaturesForWebView = (
  label: React.ReactNode,
  className: string
) => estateFeatures(tenantShortTermAccommodationRentEstateFeaturesList, label, className)

export const tenantShortTermAccommodationRentBuildingTypeOptions = [
  BuildingTypeOption.FLAT,
  BuildingTypeOption.HOUSE,
  BuildingTypeOption.ROOM,
  BuildingTypeOption.APARTMENT,
]
